export const ResetPasswordStyles = {
  lottieBackground: {
    backgroundImage:
      "linear-gradient(to right, #212a38, #283b54, #2c4d71, #2d5f90, #2973b0)",
  },
};
